import React from "react";
import { useParams, useNavigate } from 'react-router-dom';
import { removeExpense, editExpense, startRemoveExpense, startEditExpense } from '../actions/expenses';
import { useSelector, useDispatch } from 'react-redux';
import ExpenseForm from "./ExpenseForm";

const EditExpensePage = (props) => {

    const expenseId=useParams().id;
    const dispatch=useDispatch();
    const navigate=useNavigate();

    const expense=useSelector((state) => {
        return state.expenses.find(({id}) => {
            return id===expenseId;
        });
    });

    return (
        <div className='col-md-9 col-12 offset-md-3 expense-form-page'>
            <h1 className="heading">Edit Expense</h1>
            <hr />
            
            <ExpenseForm
                expense={expense}
                onSubmit={(expenses) => {
                    dispatch(startEditExpense(expense.id, expenses));
                    navigate('/');
                }}
            />
        </div>
    );
}

export default EditExpensePage;